import Link from "next/link";
import ReactHtmlParser from "react-html-parser";
import { useRouter } from "next/router";
import { ButtonsName } from "./free-content-utils";

import styles from "./styles.module.scss";

type subCardProps = {
  image?: string;
  title: string;
  description: string;
  link: string;
  typeCard?: string;
  buttonTitle: ButtonsName;
  tag?: string;
};

export default function SubCard(content: subCardProps) {
  const { image, title, description, link, typeCard, buttonTitle, tag } =
    content;

  const router = useRouter();
  const query = { ...router.query };

  return (
    <li className={styles.card}>
      <div
        className={styles.image}
        style={{
          background: `${image}`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      />
      <div className={styles.content}>
        <h2 className={styles.title}>
          {typeCard}
          {title}
        </h2>
        <div>
          {tag === "blog" ? ReactHtmlParser(description) : <p>{description}</p>}
        </div>
        {tag === "blog" || tag === "video" ? (
          <a
            href={`${link}`}
            className={styles.link}
            target="_blank"
            rel="noreferrer"
          >
            {buttonTitle}
            <svg width="32" height="16" viewBox="0 0 49 16" fill="none">
              <path
                d="M48.497 8.70711C48.8875 8.31659 48.8875 7.68342 48.497 7.2929L42.1331 0.928936C41.7425 0.538411 41.1094 0.538411 40.7188 0.928936C40.3283 1.31946 40.3283 1.95262 40.7188 2.34315L46.3757 8L40.7188 13.6569C40.3283 14.0474 40.3283 14.6805 40.7188 15.0711C41.1094 15.4616 41.7425 15.4616 42.1331 15.0711L48.497 8.70711ZM-8.91535e-08 9L47.7899 9L47.7899 7L8.91535e-08 7L-8.91535e-08 9Z"
                fill="white"
              />
            </svg>
          </a>
        ) : (
          <Link href={{ pathname: `${link}`, query: query }}>
            <a className={styles.link}>
              {buttonTitle}
              <svg width="32" height="16" viewBox="0 0 49 16" fill="none">
                <path
                  d="M48.497 8.70711C48.8875 8.31659 48.8875 7.68342 48.497 7.2929L42.1331 0.928936C41.7425 0.538411 41.1094 0.538411 40.7188 0.928936C40.3283 1.31946 40.3283 1.95262 40.7188 2.34315L46.3757 8L40.7188 13.6569C40.3283 14.0474 40.3283 14.6805 40.7188 15.0711C41.1094 15.4616 41.7425 15.4616 42.1331 15.0711L48.497 8.70711ZM-8.91535e-08 9L47.7899 9L47.7899 7L8.91535e-08 7L-8.91535e-08 9Z"
                  fill="white"
                />
              </svg>
            </a>
          </Link>
        )}
      </div>
    </li>
  );
}
